import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { de, th } from 'date-fns/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GlobalService } from 'src/app/shared/services/global.service';
import { RequestServices } from 'src/app/shared/services/request.services';

@Component({
  selector: 'app-acknowlege',
  templateUrl: './acknowlege.component.html',
  styleUrls: ['./acknowlege.component.scss']
})
export class AcknowlegeComponent implements OnInit {

  @ViewChild('content') public templateRef: TemplateRef<any>;
  checklist: any;
  
  filteredChecklist: any[] = [];
selectedDeviceName: string = '';

  etrappaddress: any

  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered modal-xl',
  };
  minDate: any = new Date().toISOString().split('T')[0];

  modalRefChild: BsModalRef
  ackForm: FormGroup;
  today = new Date().toISOString().split("T")[0];
  constructor(private modalService: BsModalService,
    public global: GlobalService,
    private service: RequestServices,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initAckForm();

  }


  initAckForm() {
    this.ackForm = this.formBuilder.group({
      id: [0, Validators.compose([Validators.nullValidator])],
      assignedProStaffId: ["", Validators.compose([Validators.required])],
      appointmentOn: [null, Validators.compose([Validators.required])],
      appointmentStartTime: [null, Validators.compose([Validators.required])],
      appointmentEndTime: [null, Validators.compose([Validators.required])],
      selectedLogIds: [[]]
    });
  }

    onCheckboxChange(event: any, data: any) {

    const control = this.ackForm.get('selectedLogIds');

    let selectedLogIds = [...(control.value || [])];

    if (event.target.checked) {

      selectedLogIds.push(data);

    } else {

      selectedLogIds = selectedLogIds.filter(
        item =>
          !(item.proid === data.proid &&
            item.consumerId === data.consumerId)
      );
    }

    control.setValue(selectedLogIds);
  }

  @Output() successEvent = new EventEmitter<void>();


  submitAckForm(obj: any) {
    obj.proId = this.global.getProObj().id;
    obj.consumerId = this.customerid;
    obj.serviceAddres = this.etrappaddress;
    localStorage.setItem('PRO_AUTO_REFRESH_PAUSED', 'true'); 

    /*
    ======================================
    CHECKBOX SELECTED
    ======================================
    */
    if (obj.selectedLogIds?.length > 0) {

    let finalLogs = [...obj.selectedLogIds];

    if (this.dashboardAlertData) {

      const dashboardLogs =
        this.buildSelectedLogFromDashboard(
          this.dashboardAlertData
        );

      const dashboardLogId = dashboardLogs[0]?.logId;

      const alreadyExists = finalLogs.some(
        x => x.logId === dashboardLogId
      );

      if (!alreadyExists) {
        finalLogs.push(...dashboardLogs);
      }
    }

    obj.selectedLogIds = finalLogs;

    obj.etrappUnitId =
      finalLogs[0].etrappUnitId;

    obj.details =
      finalLogs
        .map(x => x.definition)
        .join(', ');

    this.callAddSupportTicket(obj);
    return;
  }
    /*
    ======================================
    DASHBOARD DATA AVAILABLE
    ======================================
    */
    if (this.dashboardAlertData) {

      obj.selectedLogIds =
        this.buildSelectedLogFromDashboard(
          this.dashboardAlertData
        );

      obj.etrappUnitId =
        this.dashboardAlertData.etrappUnitId;

      obj.details =
        this.dashboardAlertData.definition;

      obj.serviceAddres =
        this.dashboardAlertData.etrappAddress;

      this.callAddSupportTicket(obj);
      return;
    }

    /*
    ======================================
    FINAL FALLBACK → CALL API
    ======================================
    */
    this.getDashboardAlertAndSubmit(obj);
  }
  cartridgeVar = {
    proArr: [],
    timeArr: [{ time: "8:00 am" }, { time: "8:30 am" }, { time: "9:00 am" }, { time: "9:30 am" }, { time: "10:00 am" }, { time: "10:30 am" }, { time: "11:00 am" }, { time: "11:30 am" }, { time: "12:00 pm" }, { time: "12:30 pm" }, { time: "1:00 pm" }, { time: "1:30 pm" }, { time: "2:00 pm" }, { time: "2:30 pm" }, { time: "3:00 pm" }, { time: "3:30 pm" }, { time: "4:00 pm" }, { time: "4:30 pm" }, { time: "5:00 pm" }],
    endTimeArr: [],
    timeDifferenceArr: ['30 minutes', '1 hour', '1.5 hours', '2 hours', '2.5 hours', '3 hours', '3.5 hours', '4 hours', '4.5 hours', '5 hours', '5.5 hours', '6 hours', '6.5 hours', '7 hours', '7.5 hours', '8 hours', '8.5 hours', '9 hours'],
  }
  customerid: any
  dashboardAlertData: any;
  currentAlertLogId: any;

  openmodal(address: any, customerid: any, alertgenerated, alertObj?) {
    this.customerid = customerid
    this.etrappaddress = address
    this.dashboardAlertData = alertObj;
    this.currentAlertLogId = alertObj?.alertLogId;
    this.ackForm.reset({
    id: 0,
    assignedProStaffId: "",
    appointmentOn: null,
    appointmentStartTime: null,
    appointmentEndTime: null,
    selectedLogIds: []
    });
    this.getAllProStaff();
    this.getchecklist(address);
    const datetovalidate = this.global.utcDateToLocal(alertgenerated);
    const datetovalidatee = new Date(datetovalidate);
    this.ackForm.controls.appointmentStartTime.clearValidators()
    this.ackForm.controls.appointmentStartTime.setValidators([this.appointmentTimeValidator(datetovalidatee)]);

  }

  buildSelectedLogFromDashboard(alert: any) {

    if (!alert) {
      return [];
    }

    return [{
      etrappUnitId: alert.etrappUnitId,
      deviceName: alert.deviceName,
      address: alert.etrappAddress,
      logId: alert.alertLogId,
      definition: alert.definition,
      alertId: alert.alertId,
      alertTypeId: alert.alertType ?? 1
    }];
  }

  getDashboardAlertAndSubmit(obj: any) {

  this.service
    .postRequest(`Dashboard/GetDashboardEtrappAlertsByProId`, {
      id: this.global.getProObj().id
    })
    .subscribe((res: any) => {

      if (res?.statusCode === "200" && res.data?.length) {

        //Find EXACT alert opened in modal
        const alert = res.data.find(
          x => x.alertLogId === this.currentAlertLogId
        );

        if (!alert) {
          this.global.showNotification(
            'Error',
            '',
            'Matching alert not found'
          );
          return;
        }

        obj.selectedLogIds =
          this.buildSelectedLogFromDashboard(alert);

        obj.etrappUnitId = alert.etrappUnitId;
        obj.details = alert.definition;
        obj.serviceAddres = alert.etrappAddress;

        this.callAddSupportTicket(obj);
      }
      else {
        this.global.showNotification(
          'Error',
          '',
          'No dashboard alert found'
        );
      }

    });
}

  callAddSupportTicket(obj: any) {
    debugger

    //localStorage.setItem('PRO_AUTO_REFRESH_PAUSED', 'false');

    this.global._show_loader = true;

    this.service
      .postRequest(
        `SupportTicket/AddSupportTicketWithDetails`,
        obj
      )
      .subscribe(
        (response) => {
          this.global._show_loader = false;

          if (response.statusCode == "201") {
            this.ackForm.patchValue({
              selectedLogIds: []
            });
            this.successEvent.emit();
            this.modalRefChild.hide();
          }
        },
        () => {
          this.global._show_loader = false;
        }
      );
  }

  appointmentTimeValidator(ticketDateTime: Date): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      if (!control.value || !this.ackForm?.value?.appointmentOn) {
        return null;
      }

      const selectedDateStr = this.ackForm.value.appointmentOn;


      const [year, month, day] = selectedDateStr.split('-').map(Number);
      const selectedDate = new Date(year, month - 1, day);

      const now = new Date();

      const [time, modifier] = control.value.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "pm" && hours < 12) hours += 12;
      if (modifier === "am" && hours === 12) hours = 0;

      selectedDate.setHours(hours, minutes, 0, 0);

      const isToday =
        selectedDate.toDateString() === now.toDateString();

      if (isToday && selectedDate <= now) {
        return { appointmentTimeInvalid: true };
      }

      if (selectedDate <= ticketDateTime) {
        return { appointmentTimeInvalid: true };
      }

      return null;
    };
  }



  getchecklist(address: any) {
    this.service.getRequest(`AcknowledgedAlerts/GetUnServicedAlertsByAddress?ServiceAddrress=${address}`)
      .subscribe((response) => {

        if (response.statusCode === 200) {
          this.checklist = response.data
          this.global._show_loader = false;
          this.modalRefChild = this.modalService.show(this.templateRef, this.config);

        }
        else if (response.statusCode === 409) {

          this.checklist = [];
          this.global._show_loader = false;
          this.modalRefChild = this.modalService.show(this.templateRef, this.config);

        }
        else {
          this.global._show_loader = false;
          this.global.showNotification('Error', '', 'No Record exist');
        }
      }, (error) => {
        this.global.showNotification('Error', '', 'Something Went Wrong');
        this.global._show_loader = false;
      });
  }

  closeModel() {
    this.modalRefChild.hide();
    this.modalRefChild = undefined;
    localStorage.setItem('PRO_AUTO_REFRESH_PAUSED', 'true');
  }

  onDateChange() {
    this.ackForm.patchValue({
      appointmentStartTime: null,
      appointmentEndTime: null
    });
  }

  getTime(obj: any, isEdit?: any) {
    let indexOfTime = this.cartridgeVar.timeArr.findIndex(x => x.time === obj);
    let cloneArray = [...this.cartridgeVar.timeArr];
    this.cartridgeVar.endTimeArr = cloneArray.splice(indexOfTime + 1, cloneArray.length);
    if (this.ackForm.value.appointmentEndTime !== null && !isEdit) {
      this.ackForm.controls['appointmentEndTime'].setValue("")
    }
    this.cartridgeVar.endTimeArr.map((item: any, index) => {
      return item.diff = " - " + this.cartridgeVar.timeDifferenceArr[index];
    });
  }

  getAllProStaff() {
    this.global._show_loader = true;
    this.service.getRequest(`ProStaff/GetAllProStaffByProId?ProId=${this.global.getProObj().id}`)
      .subscribe(
        (response) => {
          this.global._show_loader = false;
          if (response.statusCode == "200") {

            this.cartridgeVar.proArr = response.data;

          }
          else {
            this.global.showNotification("Error", "", "Something went wrong while fetching pro data.");
          }
        },
        (error) => {
          this.global.showNotification("Error", "", "Something went wrong while fetching pro data.");
        }
      );
  }

}
